import { CheckCircle2 } from 'lucide-react';
import type { ReactElement } from 'react';

import { AppSourceButton } from './AppSourceButton';
import { OFFICE_HOSTS } from './constants';
import { MagicCard } from './MagicCard';
import { OfficeHostLogo } from './OfficeLogos';
import { Reveal } from './Reveal';

export function HostsSection(): ReactElement {
  return (
    <section id="hosts">
      <Reveal>
        <div className="mx-auto max-w-5xl px-5 py-14">
          <p className="text-primary mb-3 font-mono text-[11px] tracking-[0.18em] uppercase">
            Microsoft Office
          </p>
          <h2 className="text-foreground text-xl font-semibold tracking-tight">
            Three hosts, three panes
          </h2>
          <p className="text-muted-foreground mt-2 max-w-xl text-sm leading-relaxed">
            DocuID is not one mixed file browser dropped into every app. Word, Excel, and PowerPoint
            each get their own pane, and each pane only lists files that host can open.
          </p>

          <ul className="mt-8 grid gap-4 sm:grid-cols-3">
            {OFFICE_HOSTS.map((host) => (
              <li key={host.id}>
                <MagicCard className="flex h-full flex-col rounded-2xl">
                  <div className="p-5">
                    <div className="flex items-center gap-3">
                      <OfficeHostLogo hostId={host.id} className="size-9 shrink-0" />
                      <div>
                        <p className="text-foreground text-sm font-semibold">{host.name}</p>
                        <p className="text-muted-foreground text-[11px]">DocuID add-in</p>
                      </div>
                      <CheckCircle2 className="text-primary ml-auto size-4 shrink-0" />
                    </div>
                    <p className="text-muted-foreground mt-3 text-sm leading-relaxed">
                      {host.summary}
                    </p>
                  </div>
                </MagicCard>
              </li>
            ))}
          </ul>

          <div className="mt-6 flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-center">
            <p className="text-muted-foreground text-xs">
              One AppSource listing. Desktop and web. Word, Excel, and PowerPoint only.
            </p>
            <AppSourceButton />
          </div>
        </div>
      </Reveal>
    </section>
  );
}
